import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-underwriting-checklist',
  templateUrl: './underwriting-checklist.component.html',
  styles: [
    'table {display:block; margin-bottom:1em}',
    '.mat-mdc-table {width: 100%;max-height: 500px;overflow: auto;}',
    'tr.element-row:hover{background: whitesmoke}',
	  'a {text-decoration: none;}',
    '.loading-shade {position: absolute;top: 0;left: 0;bottom: 56px;right: 0;background: rgba(136, 134, 134, 0.15);z-index: 1;display: flex;align-items: center;justify-content: center;}'
  ]
})
export class UnderwritingChecklistComponent {
  @ViewChild('paginator') paginator:MatPaginator;
  @Output() sendUW = new EventEmitter<any>();
  constructor(private apiService:LegacyApiService){}
  uwcColumns: string[] = ['name', 'province','agencyName', 'note'];
  dataSourceUWChecklist:MatTableDataSource<string[]>;
  isLoading = true;
  totalUW:number;
  serviceSubscription:Subscription;
  async ngAfterViewInit(): Promise<void> {
    this.dataSourceUWChecklist = new MatTableDataSource(await this.underwritingChecklist(['Underwriting Checklist']));
    this.dataSourceUWChecklist.paginator=this.paginator;
    this.totalUW=this.dataSourceUWChecklist.filteredData?.map((item:any)=>item.Amount).reduce((prev,next)=>prev+next,0);
    this.sendTotalCountandAmount(this.dataSourceUWChecklist?.filteredData.length,this.totalUW);
  };
  underwritingChecklist(stageName):Promise<any>{
    return new Promise((resolve,reject)=>{
      this.isLoading=true;
      this.serviceSubscription = this.apiService.underwritingDashboardQueues(stageName).subscribe((res:any) => {
        if (res.message.statusCode === 200) {
          const arr = JSON.parse(res.message.body);
          this.isLoading=false;
          resolve(arr.data);
        }else{
          this.isLoading=false;
          resolve([])
        }
      })
    })
  }

  sendTotalCountandAmount(count:number,amount:number){
    const result = {count:count,amount:amount};
    this.sendUW.emit(result);
  }

  ngOnDestroy() {
    this.serviceSubscription.unsubscribe();
  }
}
